// Sends a visitor message to the submitInboxMessage Function, which checks it and writes the inbox doc.
export async function submitInboxMessage(payload) {
  const res = await fetch(process.env.VUE_APP_SUBMIT_INBOX_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  })
  if (!res.ok) throw new Error(`submitInboxMessage failed: ${res.status}`)
}
